// LR-441: `all` is the `['custodians']` prefix. Invalidating it also matches the
// trade-entry dropdown's key (`tradesKeys.custodians`, ['custodians', params]),
// so creating/editing a custodian refreshes both the register and the dropdown.
export const custodianKeys = {
  all: ['custodians'] as const,
  registry: () => [...custodianKeys.all, 'registry'] as const,
};
